import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { intl } from "../../../i18n/provider";

import TextField from "@mui/material/TextField";
import Modal from "../../common/Modal";
import TextFieldGroup from "./../../common/TextFieldGroup";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import {
  getCompanySettings,
  editCompaanySettingsValue,
  deleteCompanySetting,
} from "../../../actions/companiesAction";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import Box from "@mui/material/Box";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import ApiRequest from "../../../actions/ApiRequest";

const CompanySettings = ({
  getCompanySettings,
  editCompaanySettingsValue,
  deleteCompanySetting,
  companyId,
  companiesSettings,
  isDarktheme,
}) => {
  const [loading, setLoading] = useState(false);
  const intle = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [companySettings, setCompanySettings] = useState([]);
  const [editSettingValueModal, setEditSettingValueModal] = useState(false);
  const [settingValue, setSettingsValue] = useState(null);
  const [descValue, setDescValue] = useState(null);
  const [settingsName, setSettingsName] = useState(null);
  const [modalSubmitLoading, setModalSubmitLoading] = useState(false);
  const [refIndex, setRefIndex] = useState(null);
  const [dropDownValue, setDropDownValue] = React.useState("Any text");

  const [open, setOpen] = React.useState(false);
  const [filterData, setFilterData] = useState([]);
  let { id } = useParams();

  useEffect(() => {
    let source = ApiRequest.CancelToken.source();

    if (!id) {
      id = companyId;
    }
    setLoading(true);
    if (companiesSettings[id]?.length > 0) {
      setLoading(false);
      setCompanySettings(companiesSettings[id]);
      setFilterData(companiesSettings[id]);
    } else {
      getCompanySettings(id, source).then((data) => {
        setLoading(false);
        setCompanySettings(data);
      });
    }

    return () => {
      source.cancel();
    };
  }, [companiesSettings[id]?.length]);

  const handleDropDownChange = (event) => {
    setDropDownValue(event.target.value);
  };

  const onChangeDesc = (e) => {
    setDescValue(e.target.value);
  };
  const SearchfliterData = (e) => {
    const { value } = e.target;
    switch (dropDownValue) {
      case "Any text":
        return setFilterData(
          companiesSettings[id]
            ? companiesSettings[id].filter(
                (company) =>
                  company.settings_name
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                  company.setting_value
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                  company.en_desciption
                    .toLowerCase()
                    .includes(value.toLowerCase())
              )
            : companiesSettings[companyId].filter(
                (company) =>
                  company.settings_name
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                  company.setting_value
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                  company.en_desciption
                    .toLowerCase()
                    .includes(value.toLowerCase())
              )
        );
        break;
      case "Name":
        return setFilterData(
          companiesSettings[id]
            ? companiesSettings[id].filter((company) =>
                company.settings_name
                  .toLowerCase()
                  .includes(value.toLowerCase())
              )
            : companiesSettings[companyId].filter((company) =>
                company.settings_name
                  .toLowerCase()
                  .includes(value.toLowerCase())
              )
        );
        break;
      case "Value":
        return setFilterData(
          companiesSettings[id]
            ? companiesSettings[id]?.filter((company) =>
                company.setting_value
                  .toLowerCase()
                  .includes(value.toLowerCase())
              )
            : companiesSettings[companyId]?.filter((company) =>
                company.setting_value
                  .toLowerCase()
                  .includes(value.toLowerCase())
              )
        );
        break;
      case "Description":
        return setFilterData(
          companiesSettings[id]
            ? companiesSettings[id]?.filter((company) =>
                company.en_desciption
                  .toLowerCase()
                  .includes(value.toLowerCase())
              )
            : companiesSettings[companyId]?.filter((company) =>
                company.en_desciption
                  .toLowerCase()
                  .includes(value.toLowerCase())
              )
        );
        break;
      default:
        break;
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleEditClick = (value, name, desc, i) => {
    setSettingsValue(value);
    setSettingsName(name);
    setDescValue(desc);
    setEditSettingValueModal(true);
    setRefIndex(i);
  };

  const onChange = (e) => {
    const { value } = e.target;
    setSettingsValue(value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setModalSubmitLoading(true);
    editCompaanySettingsValue({
      name: companyId || id,
      settings_name: settingsName,
      settings_value: settingValue,
      des: descValue,
    }).then((res) => {
      if (res) {
        let companySettingsArray = companySettings;
        companySettingsArray[refIndex]["setting_value"] = settingValue;
        companySettingsArray[refIndex][`${intle.locale}_desciption`] =
          descValue;
        setCompanySettings(companySettingsArray);
      }
      setEditSettingValueModal(false);
      setModalSubmitLoading(false);
    });
  };

  const handleDeleteClick = (settingName) => {
    console.log('🗑️ Delete icon clicked for setting:', settingName);
    console.log('Company ID:', companyId || id);
    
    // Show confirmation dialog
    const confirmMessage = `Are you sure you want to delete the setting "${settingName}"?`;
    const userConfirmed = window.confirm(confirmMessage);
    
    console.log('User confirmation:', userConfirmed);
    
    if (userConfirmed) {
      console.log('✅ Delete confirmed, calling deleteCompanySetting action');
      console.log('deleteCompanySetting function type:', typeof deleteCompanySetting);
      
      try {
        // Call the Redux action (it's already wrapped in dispatch by connect)
        const resultPromise = deleteCompanySetting(companyId || id, settingName);
        console.log('Action called, promise returned:', resultPromise);
        
        if (resultPromise && typeof resultPromise.then === 'function') {
          console.log('Promise chain starting...');
          resultPromise
            .then((success) => {
              console.log('✅ Delete API completed, success:', success);
              if (success) {
                // Remove the deleted item from the local state using settings_name
                const updatedSettings = companySettings.filter(
                  (company) => company.settings_name !== settingName
                );
                const updatedFilterData = filterData.length > 0 
                  ? filterData.filter((company) => company.settings_name !== settingName)
                  : [];
                
                setCompanySettings(updatedSettings);
                setFilterData(updatedFilterData);
                console.log('✅ Local state updated, item removed from UI');
              } else {
                console.log('❌ Delete failed on backend');
              }
            })
            .catch((error) => {
              console.error('❌ Delete promise error:', error);
            });
        } else {
          console.error('❌ deleteCompanySetting did not return a promise!', resultPromise);
        }
      } catch (error) {
        console.error('❌ Error calling deleteCompanySetting:', error);
      }
    } else {
      console.log('❌ Delete cancelled by user');
    }
  };

  return (
    <div
      className={
        !isDarktheme
          ? "d-flex flex-column align-items-center mt-8"
          : "d-flex flex-column align-items-center mt-8 "
      }
    >
      <h2 className="company-header">
        {(id === "msg_api" ? "Messaging System" : id) || companyId}
      </h2>
      <Box 
        sx={{ 
          display: "flex", 
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "stretch" : "baseline",
          gap: isMobile ? 2 : 1,
          mb: 3,
          px: isMobile ? 2 : 0
        }}
      >
        <TextField
          sx={!isDarktheme ? { width: isMobile ? '100%' : 'auto' } : { background: "white", width: isMobile ? '100%' : 'auto' }}
          id="outlined-basic"
          label="Search"
          variant="filled"
          size="small"
          onChange={SearchfliterData}
        />
        <FormControl sx={{ minWidth: isMobile ? '100%' : 215 }} size="medium">
          <InputLabel
            className={!isDarktheme ? "" : "text-light"}
            id="demo-controlled-open-select-label"
          >
            {intl.formatMessage({ id: "Search options" })}
          </InputLabel>
          <Select
            className={!isDarktheme ? "" : "text-light"}
            labelId="demo-controlled-open-select-label"
            id="demo-controlled-open-select"
            open={open}
            onClose={handleClose}
            onOpen={handleOpen}
            value={dropDownValue}
            label={intl.formatMessage({ id: "search" })}
            onChange={handleDropDownChange}
            placeholder="Any text"
          >
            <MenuItem value="Any text">
              {intl.formatMessage({ id: "Any text" })}
            </MenuItem>
            <MenuItem value="Description">
              {intl.formatMessage({ id: "Description" })}
            </MenuItem>
            <MenuItem value="Value">
              {intl.formatMessage({ id: "value" })}
            </MenuItem>
            <MenuItem value="Name">
              {intl.formatMessage({ id: "Name" })}
            </MenuItem>
          </Select>
        </FormControl>
      </Box>
      <TableContainer sx={{ overflowX: 'auto', maxWidth: '100%' }}>
        <Table
          sx={{ minWidth: isMobile ? 300 : 650, margin: "auto" }}
          size={isSmallMobile ? "small" : "small"}
          aria-label="a dense table"
        >
          <TableHead>
            <TableRow>
              {!isSmallMobile && (
                <TableCell
                  className={!isDarktheme ? "" : "text-light"}
                  width={isMobile ? "10%" : "20%"}
                >
                  {intl.formatMessage({ id: "Index" })}
                </TableCell>
              )}
              <TableCell
                className={!isDarktheme ? "" : "text-light"}
                width={isMobile ? "25%" : "20%"}
              >
                {intl.formatMessage({ id: "Setting name" })}
              </TableCell>
              <TableCell
                className={!isDarktheme ? "" : "text-light"}
                width={isMobile ? "25%" : "20%"}
              >
                {intl.formatMessage({ id: "Setting value" })}
              </TableCell>
              {!isSmallMobile && (
                <TableCell
                  className={!isDarktheme ? "" : "text-light"}
                  width={isMobile ? "30%" : "40%"}
                >
                  {intl.formatMessage({ id: "Description" })}
                </TableCell>
              )}
              <TableCell
                className={!isDarktheme ? "" : "text-light"}
                align="center"
                width={isMobile ? "10%" : "auto"}
              >
                {intl.formatMessage({ id: "Edit" })}
              </TableCell>
              <TableCell
                className={!isDarktheme ? "" : "text-light"}
                align="center"
                width={isMobile ? "10%" : "auto"}
              >
                {intl.formatMessage({ id: "Delete" })}
              </TableCell>
            </TableRow>
          </TableHead>
          {!loading && (
            <TableBody>
              {companySettings && filterData.length === 0
                ? companySettings.map((company, i) => (
                    <TableRow
                      key={i.toString()}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      {!isSmallMobile && (
                        <TableCell
                          className={!isDarktheme ? "" : "text-light"}
                          width={isMobile ? "10%" : "20%"}
                          style={{ wordBreak: "break-all", alignItems: "center" }}
                        >
                          {company.index}
                        </TableCell>
                      )}
                      <TableCell
                        className={!isDarktheme ? "" : "text-light"}
                        width={isMobile ? "30%" : "20%"}
                        style={{ wordBreak: "break-all" }}
                      >
                        {company.settings_name}
                      </TableCell>
                      <TableCell
                        className={!isDarktheme ? "" : "text-light"}
                        width={isMobile ? "30%" : "20%"}
                        style={{ wordBreak: "break-all" }}
                      >
                        {company.setting_value}
                      </TableCell>
                      {!isSmallMobile && (
                        <TableCell
                          className={!isDarktheme ? "" : "text-light"}
                          width={isMobile ? "25%" : "40%"}
                          style={{ wordBreak: "break-all" }}
                          component="th"
                          scope="row"
                        >
                          {company[`${intle.locale}_desciption`]}
                        </TableCell>
                      )}
                      <TableCell
                        className={!isDarktheme ? "" : "text-light"}
                        align="center"
                      >
                        <IconButton
                          color="primary"
                          onClick={() =>
                            handleEditClick(
                              company.setting_value,
                              company.settings_name,
                              company[`${intle.locale}_desciption`],
                              i
                            )
                          }
                          size="small"
                          aria-label="edit"
                        >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell
                        className={!isDarktheme ? "" : "text-light"}
                        align="center"
                      >
                        <IconButton
                          color="error"
                          onClick={(e) => {
                            alert('DELETE CLICKED: ' + company.settings_name);
                            console.log('🔴 DELETE BUTTON CLICKED!');
                            console.log('Setting name:', company.settings_name);
                            console.log('Event:', e);
                            e.preventDefault();
                            e.stopPropagation();
                            handleDeleteClick(company.settings_name);
                          }}
                          size="small"
                          aria-label="delete"
                          title={`Delete ${company.settings_name}`}
                          style={{ pointerEvents: 'auto', zIndex: 1000 }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                : companySettings &&
                  filterData.map((company, i) => (
                    <TableRow
                      key={i.toString()}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      {!isSmallMobile && (
                        <TableCell
                          className={!isDarktheme ? "" : "text-light"}
                          width={isMobile ? "10%" : "20%"}
                          style={{ wordBreak: "break-all", alignItems: "center" }}
                        >
                          {company.index}
                        </TableCell>
                      )}
                      <TableCell
                        className={!isDarktheme ? "" : "text-light"}
                        width={isMobile ? "30%" : "20%"}
                        style={{ wordBreak: "break-all" }}
                      >
                        {company.settings_name}
                      </TableCell>
                      <TableCell
                        className={!isDarktheme ? "" : "text-light"}
                        width={isMobile ? "30%" : "20%"}
                        style={{ wordBreak: "break-all" }}
                      >
                        {company.setting_value}
                      </TableCell>
                      {!isSmallMobile && (
                        <TableCell
                          className={!isDarktheme ? "" : "text-light"}
                          width={isMobile ? "25%" : "40%"}
                          style={{ wordBreak: "break-all" }}
                          component="th"
                          scope="row"
                        >
                          {company[`${intle.locale}_desciption`]}
                        </TableCell>
                      )}
                      <TableCell
                        className={!isDarktheme ? "" : "text-light"}
                        align="center"
                      >
                        <IconButton
                          color="primary"
                          onClick={() =>
                            handleEditClick(
                              company.setting_value,
                              company.settings_name,
                              company[`${intle.locale}_desciption`],
                              i
                            )
                          }
                          size="small"
                          aria-label="edit"
                        >
                          <EditIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell
                        className={!isDarktheme ? "" : "text-light"}
                        align="center"
                      >
                        <IconButton
                          color="error"
                          onClick={(e) => {
                            alert('DELETE CLICKED: ' + company.settings_name);
                            console.log('🔴 DELETE BUTTON CLICKED!');
                            console.log('Setting name:', company.settings_name);
                            console.log('Event:', e);
                            e.preventDefault();
                            e.stopPropagation();
                            handleDeleteClick(company.settings_name);
                          }}
                          size="small"
                          aria-label="delete"
                          title={`Delete ${company.settings_name}`}
                          style={{ pointerEvents: 'auto', zIndex: 1000 }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>
      {loading && <CircularProgress size={80} sx={{ marginTop: "160px" }} />}
      <Modal
        visible={editSettingValueModal}
        onClose={() => setEditSettingValueModal(false)}
        width={isMobile ? "95vw" : "45vw"}
        title="Edit"
      >
        <form
          onSubmit={handleSubmit}
          style={{ width: "90%", margin: "20px auto" }}
        >
          <TextFieldGroup
            placeholder="settings value"
            name="settings value"
            type="text"
            value={settingValue}
            label={settingsName}
            onChange={onChange}
            required={true}
          />
          <div style={{ width: "59%" }}>
            <div style={{ padding: "10px 0" }}>
              {intl.formatMessage({ id: "Description" })}
            </div>
            <TextField
              id="outlined-multiline-flexible"
              multiline
              maxRows={4}
              placeholder="Description"
              name="Description"
              type="text"
              value={descValue}
              onChange={onChangeDesc}
              style={{ width: "100%" }}
            />
          </div>
          <div
            className="d-flex justify-content-end align-items-center mt-4"
            style={{ width: "100%" }}
          >
            <button
              className="btn btn-danger mx-3"
              onClick={() => setEditSettingValueModal(false)}
            >
              {intl.formatMessage({ id: "Cancel" })}
            </button>
            <button type="submit" className="btn btn-primary">
              {modalSubmitLoading ? (
                <CircularProgress sx={{ color: "white" }} size={20} />
              ) : (
                `${intl.formatMessage({ id: "submit" })}`
              )}
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};
const mapStateToProps = ({
  companies: { companiesSettings },
  darkTheme: { isDarktheme },
}) => ({
  companiesSettings,
  isDarktheme,
});

export default connect(mapStateToProps, {
  getCompanySettings,
  editCompaanySettingsValue,
  deleteCompanySetting,
})(CompanySettings);
